export const formatAuthorizationHeader = (token: string | undefined) =>
  token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
